'use strict';

var _ = require('lodash');
var SearchCriteriaFilterBuilderService = function SearchCriteriaFilterBuilderService($filter, SearchCriteriaRule, currentStateCriteriaService, visibilityManager, momentService, configurationService) {
  var SEPARATOR = '-';
  var rmMomentFormat = $filter('rmMomentFormat');
  var areAllFiltersSelected = function areAllFiltersSelected(appliedBrushes) {
    return appliedBrushes.dateRange && appliedBrushes.legs;
  };
  var getCurrentSearchCriteria = function getCurrentSearchCriteria() {
    return currentStateCriteriaService.getSearchCriteria().rules;
  };
  function addDataLegRules(rules, leg, legId) {
    var legIdRule = new SearchCriteriaRule({
      field: 'legs.legId',
      operator: '='
    });
    legIdRule.leftOperand = legId;
    rules.push(legIdRule);
    var legRule = new SearchCriteriaRule({
      field: 'custom:leg',
      operator: '='
    });
    legRule.leftOperand = leg;
    rules.push(legRule);
  }
  function constructLegId(flightCarrier, flightNumber, legDepartureDateMoment, leg) {
    var carrier = flightCarrier || configurationService.getHostCarrier();
    var origin = _.split(leg, SEPARATOR)[0];
    var destination = _.split(leg, SEPARATOR)[1];
    var departureDate = rmMomentFormat(legDepartureDateMoment, 'DATE_ISO');
    return origin + '.' + carrier + '.' + flightNumber + '[' + departureDate + ']' + '.' + destination;
  }
  function addRulesFromAppliedBrushes(appliedBrushes, rules) {
    _.forEach(appliedBrushes.flightLevel.secondaryData, function (dataObj) {
      var legId = constructLegId(dataObj.carrier, dataObj.flightNumber, dataObj.legDepartureDateMoment, dataObj.leg);
      addDataLegRules(rules, dataObj.leg, legId);
    });
  }
  var buildFilter = function buildFilter(selectedRowsCabin) {
    var appliedBrushes = visibilityManager.getAppliedBrushed();
    if (selectedRowsCabin && selectedRowsCabin.length > 0 || areAllFiltersSelected(appliedBrushes)) {
      var rules = [];
      var currentCriteria = getCurrentSearchCriteria();
      rules.push.apply(rules, currentCriteria);
      if (selectedRowsCabin && selectedRowsCabin.length > 0) {
        _.forEach(selectedRowsCabin, function (row) {
          addDataLegRules(rules, row.leg, row.legId);
        });
      } else {
        addRulesFromAppliedBrushes(appliedBrushes, rules);
      }
      return rules;
    }
  };
  return {
    buildFilter: buildFilter
  };
};
SearchCriteriaFilterBuilderService.$inject = ['$filter', 'SearchCriteriaRuleFactory', 'CurrentStateCriteriaService', 'FlightComponentVisibilityManagerService', 'MomentService', 'ConfigurationService'];
module.exports = SearchCriteriaFilterBuilderService;